<template>
	<div class="pages">
		<sub-ibox-title ><p slot="title">模板消息管理</p></sub-ibox-title>
		<section class="content">
			<div class="">
				<!--<mt-switch v-model="isSwitch">{{isSwitch ? '关闭模板消息':'开启模板消息'}}</mt-switch>-->
				<a v-show="list.length > 0" class="z-btn z-btn-primary b-r-3" @click="handleCloseTplMsg">关闭模板消息</a>
				<a v-show="list.length <= 0" class="z-btn z-btn-primary b-r-3" @click="handleOpenTplMsg">开启模板消息</a>
			</div>
			<z-table class="m-t-15" :offset=0 :count=1 :total-count=1>
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list || []">
					<td>{{item.tpl_num}}</td>
					<td>{{item.title}}</td>
					<td>{{item.topcolor}}</td>
					<td>{{item.textcolor}}</td>
				</tr>
				<tr slot="datasource" v-show="list.length <= 0">
					<td colspan="20"><p class="p-20">暂无记录 (˘•ω•˘)</p></td>
				</tr>
			</z-table>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'TplMsg',
		components: {
		},
		data() {
			return {
				columns :['模板编号','模板类型','头部颜色','文字颜色'],
				params:{
					isSwitch:false
				}
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.wxTplMsg.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleCloseTplMsg(){//关闭模板消息
				this.$messagebox.confirm(`确定要关闭模板消息?`).then(action => {
					this.params.isSwitch = false
					this.handleInitTplMsg()
				},()=>{});
			},
			handleOpenTplMsg(){//开启模板消息
				this.params.isSwitch = true
				this.handleInitTplMsg()
			},
			handleInitTplMsg(){//初始化模板消息
				this.initTplMsg(this.params).then(()=>{
					this.$log('初始化模板消息成功')
					this.handleGetTplMsg()
					this.$toast('操作成功')
				},(error)=>{
					this.$log(error)
					this.$toast(error)
				})
			},
			handleGetTplMsg(){//获取模板消息
				this.getTplMsg(this.params).then(()=>{
					this.$log('获取模板消息成功')
				},(error)=>{
					this.$log(error)
				})
			},
			...mapActions(['initTplMsg','getTplMsg'])
		},
		deactivated (){//页面切换出去
	    },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				vm.handleGetTplMsg()
			})
		}

	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
.sub-ibox-title{
	border-bottom: none !important;
}
</style>


// WEBPACK FOOTER //
// WxTplMsg.vue?83c72cbe